
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns020597cffbe2f6f23649adc27d932c93en from './en.yaml'
            i18n.addResourceBundle('en', '020597cffbe2f6f23649adc27d932c93', flattenObject(ns020597cffbe2f6f23649adc27d932c93en), true, true);
        
        export default '020597cffbe2f6f23649adc27d932c93';
    